module.exports = "/images/74ea1f3f2b7b7a863dd04c4a578ad473.png";